module.exports = __webpack_public_path__ + "img/tick-circle.6f12f48b.svg";